import React from "react";
import SearchBar from "./SearchBar";
import { StoreService } from "../../services/store-service";
import DefaultLogo from "../../assets/images/logo.png";
import styles from "./Header.module.css";

interface HeaderProps {
  onSearch?: (query: string) => void;
}

const Header: React.FC<HeaderProps> = ({ onSearch }) => {
  const businessProfile = StoreService.GetData("business-profile");
  const logo = businessProfile?.logo || DefaultLogo;
  const title = businessProfile?.name || "سالن زیبایی مینا راد";

  return (
    <div className={`shadow-sm py-4 px-4 ${styles.headerContainer}`}>
      <div className="d-flex align-items-center justify-content-end">
        <div className={`me-2 text-end ${styles.welcomeText}`}>
          <h5 className="fw-bold mb-1" style={{ color: "var(--theme-title)" }}>{title}</h5>
          <p className="mb-0" style={{ color: "var(--theme-textSecondary)" }}>خوش آمدید</p>
        </div>
        <div className={styles.logoWrapper}>
          <img src={logo} alt="لوگو" className={styles.logo} />
        </div>
      </div>
      
      <div className={`mt-3 mx-auto ${styles.searchContainer}`}>
        <SearchBar onSearch={onSearch ?? (() => {})} />
      </div>
    </div>
  );
};

export default Header;
